import { environment } from '../../../environments/environment';

const INIT_FLAG = '__launchpocketClarityInitialized';

function isValidClarityProjectId(raw: string): boolean {
  const id = raw.trim();
  return id.length > 0 && /^[a-z0-9]+$/i.test(id);
}

/**
 * Loads the Microsoft Clarity tag for the configured project ID.
 * Equivalent to the official inline snippet (queue + async script).
 */
export function initializeMicrosoftClarity(): void {
  const raw = environment.clarityProjectId;
  if (typeof raw !== 'string' || !isValidClarityProjectId(raw)) {
    return;
  }

  const projectId = raw.trim();
  const w = window as Window & { [INIT_FLAG]?: boolean };

  if (w[INIT_FLAG]) {
    return;
  }
  w[INIT_FLAG] = true;

  const c = w as Window & Record<string, unknown>;
  const a = 'clarity';

  type ClarityStub = ((...args: never[]) => void) & { q?: IArguments[] };

  if (!c[a]) {
    function clarityStub(): void {
      const self = clarityStub as ClarityStub;
      self.q = self.q ?? [];
      // eslint-disable-next-line prefer-rest-params
      self.q.push(arguments);
    }
    c[a] = clarityStub;
  }

  const t = document.createElement('script');
  t.async = true;
  t.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
  const y = document.getElementsByTagName('script')[0];
  y?.parentNode?.insertBefore(t, y);
}
